import { connect } from 'react-redux'
import { history } from '../store'

import NewInstitution from '../components/NewInstitution'


const mapDispatchToProps = () => {
    return {
        onRedirect: () => history.replace('/edit/')
    }
}

export default connect(null, mapDispatchToProps)(NewInstitution)



/** WEBPACK FOOTER **
 ** ./src/containers/NewInstitutionContainer.js
 **/